var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSort(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.79992 4.4665C6.66659 4.59984 6.53325 4.6665 6.39992 4.6665H4.33325V10.6665C4.33325 11.0665 4.06659 11.3332 3.66659 11.3332C3.26659 11.3332 2.99992 11.0665 2.99992 10.6665V4.6665H0.933252C0.599919 4.6665 0.333252 4.39984 0.333252 4.0665C0.333252 3.93317 0.399919 3.73317 0.533252 3.6665L3.26659 0.933171C3.46659 0.666504 3.86659 0.666504 4.06659 0.866504L6.79992 3.59984C7.06659 3.8665 7.06659 4.2665 6.79992 4.4665ZM13.4666 7.53317C13.3333 7.39984 13.1999 7.33317 13.0666 7.33317H10.9999V1.33317C10.9999 0.933171 10.7333 0.666504 10.3333 0.666504C9.93325 0.666504 9.66659 0.933171 9.66659 1.33317V7.33317H7.59992C7.26659 7.33317 6.99992 7.59984 6.99992 7.93317C6.99992 8.0665 7.06659 8.2665 7.19992 8.33317L9.93325 11.0665C10.1999 11.3332 10.5333 11.3332 10.7999 11.0665L13.5333 8.33317C13.7333 8.13317 13.7333 7.73317 13.4666 7.53317Z",
    fill: "#525559"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.d58762b1dc2b84b9589eff88f40c8a37.svg";
export { ForwardRef as ReactComponent };